import PropTypes from 'prop-types';
import { faLocationDot, faHome, faClock } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import getLogo from '../../utils/getLogo';
import Card from '../common/Card';
import { activityDate2Human } from '../../utils/dateTime';
import useFavorites from '../../hooks/useFavorites';
import { useDispatch } from 'react-redux';
import { favoritesAddActivity, favoritesDelActivity } from '../../store/favoritesSlice';

const ActivityItem = ({ activity, date }) => {
	const { i18n } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const inFav = useFavorites({ type: 'activity', object: activity });
    const lang = i18n.language;
    const icon = getLogo(activity.exhibitor);
    const [ exhibitor, setExhibitor ] = useState(activity.exhibitor);

    useEffect(() => {
        setExhibitor(activity.exhibitor);
    }, [ activity ]);

    const onClick = () => {
        navigate(`../activity/${activity._id}`);
    };

    const onFavClick = () => {
        if(inFav) {
            dispatch(favoritesDelActivity(activity));
        } else {
            dispatch(favoritesAddActivity(activity));
        }
    };

    if(!activity.date.startsWith(date)) return null;

	return (
        <Card
            id={activity._id}
            name={activity.name[lang]}
            icon={icon}
            inFav={inFav}
            isHigh={exhibitor.highlight?.length > 0}
            onClick={onClick}
            onFavClick={onFavClick}
            items={[{
                icon: faHome,
                text: exhibitor.name[lang],
            },{
                icon: faClock,
                text: activityDate2Human(activity.date, lang),
            },{
                icon: faLocationDot,
                text: exhibitor.stand,
            }]}
        />
	);
};

ActivityItem.propTypes = {
    activity: PropTypes.object.isRequired,
    date: PropTypes.string.isRequired,
};

export default ActivityItem;
